/**
 * Session helpers. The admin UI can look "logged in" from a user object in
 * localStorage while the JWT is missing/invalid for the current API.
 */

export function getStoredUserData() {
  try {
    return JSON.parse(localStorage.getItem("userData") || "null");
  } catch {
    return null;
  }
}

/** True when localStorage has a JWT-shaped token (does not verify signature). */
export function hasSessionToken(userData = getStoredUserData()) {
  const token = userData?.token;
  if (!token || typeof token !== "string") return false;
  if (token === "undefined" || token === "null") return false;
  return token.split(".").length === 3;
}

export function hasAdminSession(userData = getStoredUserData()) {
  return (
    hasSessionToken(userData) &&
    String(userData?.user?.user_type || "").toLowerCase() === "admin"
  );
}
